import { SubmitHandler } from 'react-hook-form';

import { useAfterSignInPath } from 'hooks/useAfterSignInPath';
import { useTrackMagicLinkSent } from 'services/datalayer/account';

import { useEmailLinkFlow } from 'components/@account/useEmailLinkFlow';
import Form from 'components/@forms/Form';

import AuthenticationCard from './AuthenticationCard';
import AuthenticationDrawer from './AuthenticationDrawer';
import { LoginFormFields } from './types';

interface Props {
  afterSignInUrl: string;
  titleIntlId: string;
  drawer?: {
    open: boolean;
    onClose: () => void;
  };
  originSourceCategory: string;
}

const Authentication = ({
  afterSignInUrl,
  titleIntlId,
  drawer,
  originSourceCategory,
}: Props) => {
  const { emailSent, isLoading, onEmailLinkSignInOrSignup, reset } =
    useEmailLinkFlow();
  const { setAfterSignInUrl } = useAfterSignInPath();
  const trackMagicLink = useTrackMagicLinkSent();

  const handleEmailLinkSignInOrSignup: SubmitHandler<LoginFormFields> = async ({
    emailAddress,
  }) => {
    trackMagicLink({});
    setAfterSignInUrl(afterSignInUrl);
    await onEmailLinkSignInOrSignup({ emailAddress, afterSignInUrl });
  };

  const handleResetEmailFlow = () => {
    reset();
  };

  if (drawer) {
    return (
      <AuthenticationDrawer
        titleIntlId={titleIntlId}
        open={drawer.open}
        onClose={drawer.onClose}
        emailSent={emailSent}
        afterSignInUrl={afterSignInUrl}
        isLoadingEmailLink={isLoading}
        onResetEmailFlow={handleResetEmailFlow}
        originSourceCategory={originSourceCategory}
        onSubmit={handleEmailLinkSignInOrSignup}
      />
    );
  }

  return (
    <Form
      onSubmit={handleEmailLinkSignInOrSignup}
      defaultValues={{ emailAddress: '' }}
    >
      <AuthenticationCard
        titleIntlId={titleIntlId}
        emailSent={emailSent}
        afterSignInUrl={afterSignInUrl}
        isLoadingEmailLink={isLoading}
        onResetEmailFlow={handleResetEmailFlow}
        originSourceCategory={originSourceCategory}
      />
    </Form>
  );
};

export default Authentication;
